import _ from 'lodash';

export function snapImage(video) {
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
    const image = canvas.toDataURL();
    const success = image.length > 1000;
    if (success) {
        console.log('snap image success!!!');
        return image
    }
    return null;

}

export function sliceFile(blob, start, end) {
    var ok = true;
    try {
        if (!blob.slice) {
            blob.slice = blob.mozSlice || blob.webkitSlice;
        }
        //*DBG*/message.log('@'+ blob.start +' Σ'+ (blob.end - blob.start));
        // bytes ranging from `start` up to but not including `end`
        blob.chunk = blob.slice(start, end, blob.type);

    } catch (bug) {
        blob.lastError = 'upload.js@sliceFile-> can\'t slice file cause: ' + bug.toString();
        ok = false;
    }

    return ok;
}

export function splitFile(blob) {
    const chunkSize = 2 ** 20 * 5;
    let chunks = [];
    let start = 0;
    let end = chunkSize;
    let partIndex = 0;
    blob.lastError = null;


    do {
        if (end > blob.size) {
            end = blob.size;
        }

        sliceFile(blob, start, end);

        chunks[partIndex] = new File([blob.chunk], blob.name);

        // move offsets forward
        start = end;
        end += chunkSize;
        partIndex++;

    } while (start < blob.size);
    return chunks;
}